module.exports = __webpack_public_path__ + "img/Flexible Character.324cee0c.png";